import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  selectSupplierAllocations,
  selectSupplierAllocationsError,
  selectSupplierAllocationsLoading,
  selectSupplierAllocationsUpdateStatus,
  selectSupplierAllocationsUpdating,
} from './supplier.selectors';

@Injectable({ providedIn: 'root' })
export class SupplierSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly allocations = this._store.selectSignal(
    selectSupplierAllocations,
  );

  public readonly allocationsLoading = this._store.selectSignal(
    selectSupplierAllocationsLoading,
  );

  public readonly allocationsError = this._store.selectSignal(
    selectSupplierAllocationsError,
  );

  public readonly allocationsUpdating = this._store.selectSignal(
    selectSupplierAllocationsUpdating,
  );

  public readonly allocationsUpdateStatus = this._store.selectSignal(
    selectSupplierAllocationsUpdateStatus,
  );
}
